export const advantagePlanSelectType = [
    {key: 'contractNumber', value: 'Contract Number'},
    {key: 'legalEntityName', value: 'Legal Entity Name'},
    {key: 'marketingName', value: 'Marketing Name'},
    // {key: 'effectiveDate', value: 'Effective Date'},
    // {key: 'contactNumber', value: 'Contact Number'}
]